export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const CART_START = "CART_START";
export const CART_SUCCESS = "CART_SUCCESS";
export const CART_FAIL = "CART_FAIL";

export const GET_USER_NAME = "GET_USER_NAME";
export const GET_USER_PERMISSION = "GET_USER_PERMISSION";
export const GET_PROCESS_PERMISSION = "GET_PROCESS_PERMISSION";

export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_HANDLPER = "GET_USER_HANDLPER";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_LS_PERMISSION = "GET_LS_PERMISSION";
export const GET_LS_CITY = "GET_LS_CITY";
export const GET_LS_DEPARTMENT = "GET_LS_DEPARTMENT";
export const GET_LS_STATUS_CV = "GET_LS_STATUS_CV";
export const GET_LS_STATUS_TICKET = "GET_LS_STATUS_TICKET";



